<template>
    <network-slides />
</template>

<script>
import networkSlides from '@components/Instructions/slidesNetwork.vue'

export default {
  page: {
    title: 'WiFi Connection',
    meta: [
      {
        name: 'description',
        content: 'Build a smart city, one sensor at a time',
      },
    ],
  },
  components: {
    networkSlides,
  },
}
</script>
